// Bilingual groundwork (PRODUCT_REQUIREMENTS: Arabic RTL and English). Only
// foundation-page strings exist; business terminology is added by feature
// modules from approved wording, never invented here.

export const LOCALES = ['ar', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

export const DIRECTION: Readonly<Record<Locale, 'rtl' | 'ltr'>> = { ar: 'rtl', en: 'ltr' };

export interface Messages {
  readonly appName: string;
  readonly switchLanguage: string;
  readonly systemStatus: string;
  readonly loading: string;
  readonly apiUnavailable: string;
  readonly serviceInformation: string;
  readonly businessDate: string;
  readonly serverTime: string;
  readonly contractVersion: string;
  readonly readiness: string;
  readonly ready: string;
  readonly notReady: string;
  readonly session: string;
  readonly signedOut: string;
  readonly signedInAs: string;
  readonly notFound: string;
  readonly backHome: string;
  readonly unexpectedError: string;
}

export const MESSAGES: Readonly<Record<Locale, Messages>> = {
  en: {
    appName: 'Elite Residence',
    switchLanguage: 'العربية',
    systemStatus: 'System status',
    loading: 'Loading…',
    apiUnavailable: 'The service could not be reached.',
    serviceInformation: 'Service information',
    businessDate: 'Business date (Asia/Riyadh)',
    serverTime: 'Server time (UTC)',
    contractVersion: 'API contract version',
    readiness: 'Readiness',
    ready: 'Ready',
    notReady: 'Not ready',
    session: 'Session',
    signedOut: 'Not signed in. Sign-in is not available yet.',
    signedInAs: 'Signed in',
    notFound: 'Page not found.',
    backHome: 'Back to start',
    unexpectedError: 'Something went wrong.',
  },
  ar: {
    // No approved Arabic rendering of the product name exists yet; use the
    // Latin name until approved wording is provided.
    appName: 'Elite Residence',
    switchLanguage: 'English',
    systemStatus: 'حالة النظام',
    loading: 'جارٍ التحميل…',
    apiUnavailable: 'تعذّر الوصول إلى الخدمة.',
    serviceInformation: 'معلومات الخدمة',
    businessDate: 'تاريخ العمل (الرياض)',
    serverTime: 'وقت الخادم (UTC)',
    contractVersion: 'إصدار عقد الواجهة البرمجية',
    readiness: 'الجاهزية',
    ready: 'جاهز',
    notReady: 'غير جاهز',
    session: 'الجلسة',
    signedOut: 'لم يتم تسجيل الدخول. تسجيل الدخول غير متاح بعد.',
    signedInAs: 'تم تسجيل الدخول',
    notFound: 'الصفحة غير موجودة.',
    backHome: 'العودة إلى البداية',
    unexpectedError: 'حدث خطأ ما.',
  },
};

export function preferredLocale(languages: readonly string[]): Locale {
  return languages.some((l) => l.toLowerCase().startsWith('ar')) ? 'ar' : 'en';
}
